

export const TECHNICIAN_TAGS_INITIATE_FETCH_TAGS_LIST  = 'TECHNICIAN_TAGS_INITIATE_FETCH_TAGS_LIST';
export const TECHNICIAN_TAGS_FETCH_TAGS_LIST_START = 'TECHNICIAN_TAGS_FETCH_TAGS_LIST_START';
export const TECHNICIAN_TAGS_FETCH_TAGS_LIST_SUCCESS = 'TECHNICIAN_TAGS_FETCH_TAGS_LIST_SUCCESS';
export const TECHNICIAN_TAGS_FETCH_TAGS_LIST_FAIL = 'TECHNICIAN_TAGS_FETCH_TAGS_LIST_FAIL';
export const TECHNICIAN_TAGS_FETCH_TAGS_LIST_RESET = 'TECHNICIAN_TAGS_FETCH_TAGS_LIST_RESET';